export const SET_COUNTER_VALUE = 'SET_COUNTER_VALUE';
export const INCREMENT_COUNTER = 'INCREMENT_COUNTER';

export const setCounterValueAction = (counter, value) => ({ type: SET_COUNTER_VALUE, counter, value });
export const incrementCounterAction = counter => ({ type: INCREMENT_COUNTER, counter });
